"use client";

export default function ExplanationSkeleton() {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden animate-pulse">
      {/* Header */}
      <div className="flex items-center justify-between px-5 py-4 border-b border-zinc-800">
        <div className="flex items-center gap-3">
          <div className="h-6 w-20 bg-zinc-800 rounded-full" />
          <div className="h-5 w-36 bg-zinc-800 rounded-lg" />
        </div>
        <div className="h-7 w-24 bg-zinc-800 rounded-lg" />
      </div>
      {/* Section 1 */}
      <div className="border-l-2 border-zinc-800 px-5 py-5 border-b border-zinc-800/50">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-4 h-4 rounded-full bg-zinc-800" />
          <div className="h-4 w-16 bg-zinc-800 rounded" />
        </div>
        <div className="space-y-2">
          <div className="h-3 bg-zinc-800 rounded w-full" />
          <div className="h-3 bg-zinc-800 rounded w-5/6" />
          <div className="h-3 bg-zinc-800 rounded w-4/6" />
        </div>
      </div>
      {/* Section 2 */}
      <div className="border-l-2 border-zinc-800 px-5 py-5 border-b border-zinc-800/50">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-4 h-4 rounded-full bg-zinc-800" />
          <div className="h-4 w-28 bg-zinc-800 rounded" />
        </div>
        <div className="space-y-2">
          <div className="h-3 bg-zinc-800 rounded w-full" />
          <div className="h-3 bg-zinc-800 rounded w-full" />
          <div className="h-3 bg-zinc-800 rounded w-3/4" />
        </div>
      </div>
      {/* Section 3 */}
      <div className="border-l-2 border-zinc-800 px-5 py-5 border-b border-zinc-800/50">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-4 h-4 rounded-full bg-zinc-800" />
          <div className="h-4 w-24 bg-zinc-800 rounded" />
        </div>
        <div className="space-y-3">
          {[1, 2, 3]?.map((i) => (
            <div key={i} className="flex gap-3">
              <div className="w-5 h-5 rounded-full bg-zinc-800 flex-shrink-0" />
              <div className="flex-1 space-y-1.5">
                <div className="h-3 bg-zinc-800 rounded w-full" />
                <div className="h-3 bg-zinc-800 rounded w-3/4" />
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Section 4 — Code blocks */}
      <div className="border-l-2 border-zinc-800 px-5 py-5">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-4 h-4 rounded-full bg-zinc-800" />
          <div className="h-4 w-32 bg-zinc-800 rounded" />
        </div>
        <div className="space-y-3">
          <div className="rounded-xl border border-zinc-800 overflow-hidden">
            <div className="h-9 bg-zinc-800/50 border-b border-zinc-800" />
            <div className="p-4 space-y-2 bg-zinc-950/40">
              <div className="h-3 bg-zinc-800 rounded w-2/3" />
              <div className="h-3 bg-zinc-800 rounded w-1/2" />
              <div className="h-3 bg-zinc-800 rounded w-3/4" />
            </div>
          </div>
          <div className="rounded-xl border border-zinc-800 overflow-hidden">
            <div className="h-9 bg-zinc-800/50 border-b border-zinc-800" />
            <div className="p-4 space-y-2 bg-zinc-950/40">
              <div className="h-3 bg-zinc-800 rounded w-full" />
              <div className="h-3 bg-zinc-800 rounded w-2/3" />
              <div className="h-3 bg-zinc-800 rounded w-4/5" />
              <div className="h-3 bg-zinc-800 rounded w-1/2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}